import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { finalize } from 'rxjs';
import { ButtonColorEnum } from 'src/app/shared/buttons/enums/button-color.enum';
import { GetIncidentsImportDetailResponse } from '../incidents-import.model';
import { IncidentsImportService } from '../incidents-import.service';
import { IncidentImportDetailSignalrService } from './incident-import-detail-signalr.service';

@Component({
  selector: 'app-incidents-import-detail',
  templateUrl: './incidents-import-detail.component.html',
  styleUrls: ['./incidents-import-detail.component.scss'],
})
export class IncidentsImportDetailComponent implements OnInit {
  ButtonColorEnum = ButtonColorEnum;
  imports: GetIncidentsImportDetailResponse[] = [];
  page: number = 1;
  pageSize: number = 10;
  audioImportControlId: string = '';
  totalPages: number = 0;
  totalItems: number = 0;
  isLoading: boolean = false;

  constructor(
    private readonly router: Router,
    private readonly service: IncidentsImportService,
    private readonly route: ActivatedRoute,
    private readonly signalrService: IncidentImportDetailSignalrService
  ) {}

  ngOnInit(): void {
    this.getDetail();

    this.signalrService.hubConnection.on('sendnotification', () => {
      this.getDetail();
    });
    this.signalrService.startConnection();
  }

  return() {
    this.router.navigate(['/incidents-import']);
  }

  handleSelectPage(index: number) {
    this.page = index;
    this.imports = [];
    this.getDetail();
  }

  getDetail() {
    if (this.isLoading) return;

    this.isLoading = true;
    this.imports = [];

    const filters: any = {};

    filters.pageNumber = this.page;
    filters.pageSize = this.pageSize;
    filters.audioImportControlId = this.route.snapshot.paramMap
      .get('id')!
      .toString();

    this.service
      .getDetails(filters)
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe({
        next: (data) => {
          this.totalItems = data.totalItems;
          this.totalPages = data.totalPages;

          if (data.items && data.items.length > 0) {
            this.imports = data.items.map((i) => ({
              incidentId: i.incidentId,
              createdOn: i.createdOn,
              subCell: i.subCell,
              status: i.status,
              errorMessage: i.errorMessage,
            }));
          }
        },
        error: () => {
          this.imports = [];
        },
      });
  }
}
